import React from "react";
import { css } from "@emotion/react";
import { useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FullScreenModalDialog } from "main/javascripts/components/modal/FullScreenModalDialog";
import {
  isPhone,
  moreThanBreakpoint,
} from "main/javascripts/styles/base/responsiveStyle";
import { FieldButton } from "main/javascripts/components/form/FieldButton";
import { DropdownGuestPicker } from "main/javascripts/components/form/guestPicker/DropdownGuestPicker";
import { ScrollableGuestPicker } from "main/javascripts/components/form/guestPicker/ScrollableGuestPicker";
import { useAppDispatch } from "main/javascripts/store";
import {
  isCruiseGuestPickerDisplayedSelector,
  setCruiseGuestPickerDisplayed,
} from "../cruiseSlice";
import { FormNamespaces } from "main/javascripts/constants/FormConstants";

export interface IProps {
  onUpdate?: any;
  onComplete?: any;
  onHide?: any;
  styles?: any;
}

export const CruiseGuestPickerBlock: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { onUpdate, onComplete, onHide, styles = {} } = props;
  const appDispatch = useAppDispatch();
  const displayedPicker = useSelector(isCruiseGuestPickerDisplayedSelector);
  const { watch } = useFormContext();

  // TODO: 旧reducerをそのまま使用
  const breakpoint: any = useSelector<any>(
    (state) => state.breakpointReducer.breakpoint
  );

  const { t } = useTranslation(["label"]);

  const onClick: () => void = () => {
    appDispatch(setCruiseGuestPickerDisplayed(true));
  };

  const guestsFieldName = "guests";
  const onPickerUpdate = (): void => {
    if (onUpdate) {
      onUpdate();
    }
  };
  const onPickerComplete = (): void => {
    hidePicker();
    if (onComplete) {
      onComplete();
    }
  };
  const onPickerHide = () => {
    hidePicker();
    if (onHide) {
      onHide();
    }
  };

  const hidePicker: () => void = () => {
    appDispatch(setCruiseGuestPickerDisplayed(false));
  };

  const { exBlockStyle } = styles;

  const allValues = watch();
  const adultFieldName = "number_of_adult";
  const childrenFieldName = "ages_of_children";
  let values = [];
  if (allValues[guestsFieldName]) {
    values = allValues[guestsFieldName];
  }

  const valuesText = (numberValues: any): string => {
    let text = "";

    if (!numberValues) {
      return "";
    }

    const roomNumber = values.length;
    let adultNumber = 0;
    let childrenNumber = 0;
    values.map((guest) => {
      Object.keys(guest).map((key: string) => {
        if (key === adultFieldName) {
          adultNumber = adultNumber + Number(guest[key]);
        } else if (key === childrenFieldName) {
          childrenNumber = childrenNumber + (guest[key] || []).length;
        }
        return null;
      });
    });
    text = adultNumber && t("unit:numberOfAdults", { count: adultNumber });
    if (childrenNumber) {
      text = `${text} ${t("unit:numberOfChildren", {
        count: childrenNumber,
      })}`;
    }
    if (roomNumber) {
      const key = "unit:cabins";
      text = `${text} (${t(key, { count: roomNumber })})`;
    }
    return text;
  };

  const dropdownStyles = { exBlockStyle: dropdownGuestPickerBlockStyle };

  return (
    <div css={[blockStyle, exBlockStyle]}>
      <div css={inputBlockStyle}>
        <FieldButton
          label={t("cruise.numberOfGuests")}
          value={valuesText(values)}
          onClick={onClick}
          borderStyleKey="noLeft"
          fontStyleKey="small"
        />
      </div>
      {isPhone(breakpoint) ? (
        <FullScreenModalDialog
          displayed={displayedPicker}
          closeHandler={onPickerHide}
          colorMode="light"
        >
          <ScrollableGuestPicker
            namespace={FormNamespaces.cruise}
            onComplete={onPickerComplete}
          />
        </FullScreenModalDialog>
      ) : (
        <DropdownGuestPicker
          namespace={FormNamespaces.cruise}
          displayedPicker={displayedPicker}
          hidePicker={onPickerHide}
          onUpdate={onPickerUpdate}
          onComplete={onPickerComplete}
          styles={dropdownStyles}
        />
      )}
    </div>
  );
};

const blockStyle = css``;
const inputBlockStyle = css`
  display: flex;
  padding: 0;
`;
const dropdownGuestPickerBlockStyle = css`
  ${moreThanBreakpoint("tablet")} {
    //width: calc(25% + 8rem);
    width: 27rem;
  }
`;
